import { getActionTypeLabel, getActionTypeBadgeClass } from "../MakerChecker/components/Table";
import { formatDateWithTime } from "../../utils/dateFormat";
import { useState } from "react";
import PendingRequestModal from "../MakerChecker/components/PendingRequestModal";
import { ApproveRejectModal } from "../MakerChecker/PayloadModal/PayloadModal";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import LineitemPreview from "../campaign/LineitemPreview";

const LineItemMcModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <SlDrawer
          open={isOpen}
          onSlAfterHide={onClose}
          style={{ '--size': '1280px' }}>
          <div className="flex flex-col gap-4">
            <ApproveRejectModal mcAction={data} />
            <LineitemPreview campaign_id={data?.ref_table_id} />
          </div>
      </SlDrawer>
    </div>
  );
};

export default LineItemMcModal;
